import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { MatterMortgageLenderForm } from '@models/mortgage';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { UserProfileState } from '@state/user-profile';

export interface MatterRequisitionsParams {
	mortgageId: string;
}

@Injectable({
	providedIn: 'root',
})
export class MatterMortgageLenderFormsRepoService extends Repo<
	MatterMortgageLenderForm,
	MatterRequisitionsParams
> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	GetCollectionPath(pathParam: MatterRequisitionsParams): string {
		return CollectionPaths.business_matter_mortgage_lender_forms(
			this.businessId,
			this.matterId,
			pathParam.mortgageId,
		);
	}

	constructor(private db: AngularFirestore) {
		super(db);
	}
}
